// TICKETS
export const TICKETS_GET_TICKETS = 'TICKETS/GET_TICKETS';
export const TICKETS_LOAD_TICKETS = 'TICKETS/UPDATE_TICKETS';
export const TICKETS_SET_TICKETS = 'TICKETS/SET_TICKETS';
export const TICKETS_GET_TEMPLATES = 'TICKETS/GET_TEMPLATES';
export const TICKETS_LOAD_TEMPLATES = 'TICKETS/UPDATE_TEMPLATES';
export const TICKETS_SET_TEMPLATES = 'TICKETS/SET_TEMPLATES';

// ACCESS_LEVEL
export const ACCESS_LEVEL_LOAD_LEVELS = 'ACCESS_LEVEL/LOAD_LEVELS';
export const ACCESS_LEVEL_CREATE_LEVEL = 'ACCESS_LEVEL/CREATE_LEVEL';
export const ACCESS_LEVEL_DETAILS = 'ACCESS_LEVEL/DETAILS';
export const ACCESS_LEVEL_UPDATE_LEVEL = 'ACCESS_LEVEL/UPDATE_LEVEL';
export const ACCESS_LEVEL_GET_LEVELS = 'ACCESS_LEVEL/GET_LEVEL';
export const ACCESS_LEVEL_SET_LEVELS = 'ACCESS_LEVEL/UPDATE_LEVEL';

// HOROSCOPES TYPES
export const HOROSCOPES_TYPES_LOAD_TYPES = 'HOROSCOPES_TYPES/LOAD_TYPES';
export const HOROSCOPES_TYPES_GET_TYPES = 'HOROSCOPES_TYPES/GET_TYPES';
export const HOROSCOPES_TYPES_SET_TYPES = 'HOROSCOPES_TYPES/SET_TYPES';

// HOROSCOPES ANNUAL
export const HOROSCOPES_ANNUAL_SET_HOROSCOPES = 'HOROSCOPES_ANNUAL/SET_HOROSCOPES';
export const HOROSCOPES_ANNUAL_GET_HOROSCOPES = 'HOROSCOPES_ANNUAL/GET_HOROSCOPES';
export const HOROSCOPES_ANNUAL_LOAD_HOROSCOPES = 'HOROSCOPES_ANNUAL/LOAD_HOROSCOPES';
export const HOROSCOPES_ANNUAL_CREATE_HOROSCOPE = 'HOROSCOPES_ANNUAL/CREATE_HOROSCOPE';
export const HOROSCOPES_ANNUAL_DETAIL_HOROSCOPE = 'HOROSCOPES_ANNUAL/DETAIL_HOROSCOPE';
export const HOROSCOPES_ANNUAL_CHANGE_HOROSCOPE = 'HOROSCOPES_ANNUAL/CHANGE_HOROSCOPE';

// HOROSCOPES MONTHLY
export const HOROSCOPES_MONTHLIES_SET_HOROSCOPES = 'HOROSCOPES_MONTHLIES/SET_HOROSCOPES';
export const HOROSCOPES_MONTHLIES_GET_HOROSCOPES = 'HOROSCOPES_MONTHLIES/GET_HOROSCOPES';
export const HOROSCOPES_MONTHLIES_LOAD_HOROSCOPES = 'HOROSCOPES_MONTHLIES/LOAD_HOROSCOPES';
export const HOROSCOPES_MONTHLIES_CREATE_HOROSCOPE = 'HOROSCOPES_MONTHLIES/CREATE_HOROSCOPE';
export const HOROSCOPES_MONTHLIES_DETAIL_HOROSCOPE = 'HOROSCOPES_MONTHLIES/DETAIL_HOROSCOPE';
export const HOROSCOPES_MONTHLIES_CHANGE_HOROSCOPE = 'HOROSCOPES_MONTHLIES/CHANGE_HOROSCOPE';

// HOROSCOPES DAILIES
export const HOROSCOPES_DAILIES_SET_HOROSCOPES = 'HOROSCOPES_DAILIES/SET_HOROSCOPES';
export const HOROSCOPES_DAILIES_GET_HOROSCOPES = 'HOROSCOPES_DAILIES/GET_HOROSCOPES';
export const HOROSCOPES_DAILIES_LOAD_HOROSCOPES = 'HOROSCOPES_DAILIES/LOAD_HOROSCOPES';
export const HOROSCOPES_DAILIES_CREATE_HOROSCOPE = 'HOROSCOPES_DAILIES/CREATE_HOROSCOPE';
export const HOROSCOPES_DAILIES_DETAIL_HOROSCOPE = 'HOROSCOPES_DAILIES/DETAIL_HOROSCOPE';
export const HOROSCOPES_DAILIES_CHANGE_HOROSCOPE = 'HOROSCOPES_DAILIES/CHANGE_HOROSCOPE';

// HOROSCOPES KEYWORDS
export const HOROSCOPES_KEYWORDS_SET_HOROSCOPES = 'HOROSCOPES_KEYWORDS/SET_HOROSCOPES';
export const HOROSCOPES_KEYWORDS_GET_HOROSCOPES = 'HOROSCOPES_KEYWORDS/GET_HOROSCOPES';
export const HOROSCOPES_KEYWORDS_LOAD_HOROSCOPES = 'HOROSCOPES_KEYWORDS/LOAD_HOROSCOPES';
export const HOROSCOPES_KEYWORDS_CREATE_HOROSCOPE = 'HOROSCOPES_KEYWORDS/CREATE_HOROSCOPE';
export const HOROSCOPES_KEYWORDS_DETAIL_HOROSCOPE = 'HOROSCOPES_KEYWORDS/DETAIL_HOROSCOPE';
export const HOROSCOPES_KEYWORDS_CHANGE_HOROSCOPE = 'HOROSCOPES_KEYWORDS/CHANGE_HOROSCOPE';

//APPLE APPLICATIONS
export const APPLE_APPS_SET_APPS = 'APPLE_APPS/SET_APPS';
export const APPLE_APPS_GET_APPS = 'APPLE_APPS/GET_APPS';
export const APPLE_APPS_LOAD_APPS = 'APPLE_APPS/LOAD_APPS';